import fetch from "auth/FetchInterceptor";

const StudentsService = {};

const studentEndpointPrefix = "/student";

StudentsService.getStudents = async () =>
  await fetch(`${studentEndpointPrefix}/getAll`, {
    method: "GET",
  });

StudentsService.getStudentById = async (StudentId) =>
  await fetch(`${studentEndpointPrefix}/getById/${StudentId}`, {
    method: "GET",
  });

StudentsService.createStudent = async (data) =>
  await fetch({
    url: `${studentEndpointPrefix}/create`,
    method: "POST",
    data,
  });

StudentsService.updateStudent = async (StudentId, data) =>
  await fetch(`${studentEndpointPrefix}/update/${StudentId}`, {
    method: "PUT",
    data,
  });

StudentsService.deleteStudentById = async (StudentId) =>
  await fetch(`${studentEndpointPrefix}/deleteById/${StudentId}`, {
    method: "DELETE",
  });

StudentsService.validateStudent = async (StudentId) =>
  await fetch(`${studentEndpointPrefix}/validateAccount/${StudentId}`, {
    method: "POST",
  });

StudentsService.banStudent = async (StudentId) =>
  await fetch(`${studentEndpointPrefix}/bannedAccount/${StudentId}`, {
    method: "POST",
  });

StudentsService.resetPasswordByAdmin = async (StudentId) =>
  await fetch(`${studentEndpointPrefix}/reset-password-by-admin/${StudentId}`, {
    method: "POST",
  });

StudentsService.updateStudentFormation = async (id, data) =>
  await fetch(`/student-formation/update/${id}`, {
    method: "PUT",
    data,
  });


export default StudentsService;
